// extracted by mini-css-extract-plugin
export var toggle = "toggleSwitch-module--toggle--b4bae";
export var rightLabel = "toggleSwitch-module--rightLabel--f7019";
export var leftLabel = "toggleSwitch-module--leftLabel--f0189";
export var label = "toggleSwitch-module--label--826ff";